import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import BancontactCheckoutForm from "./BancontactCheckoutForm";

const stripePromise = loadStripe(process.env.REACT_APP_PUBLIC_STRIPE_KEY);

const BancontactCheckout = ({ initialData }) => {
  return (
    <Elements stripe={stripePromise}>
      <BancontactCheckoutForm data={initialData} />
    </Elements>
  );
};

export default BancontactCheckout;
